module.exports = __webpack_public_path__ + "static/media/24_A.a000c64a.png";